







































































































































































































































































































import Vue from 'vue';
import * as deviceFactory from './deviceFactory';
import config from './map.config';
import mapStyles from './mapStyles';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import API, { Types } from '@/modules/API';
import isEqual from 'lodash/isEqual';
import { cloneDeep } from 'lodash';
import ExportData from '@/components/ExportData.vue';
import moment from 'moment';
import { gmapApi } from '@/plugins/google-maps';
import PropEditor from '@/components/PropEditor.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import Legend from '@/pages/mapView/Legend.vue';
import MQTT from '@/modules/MQTT';
import { Device, FloodSensor, GmapMapRef } from '@/modules/Types';
import { getMapIcon, buildCabinetByIdMap } from '@/pages/mapView/components/map/getMapIcon';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

const mapMaxZoom = 23;
const mapMinZoom = 2;

const defaultStyleSheet = [
  { value: 'defaultMode', name: 'Default' },
  { value: 'silverMode', name: 'Silver' },
  { value: 'nightMode', name: 'Night mode' }
];

@Component({ 
  components: {
    Legend,
    ExportData,
    PropEditor,
    ConfirmDialog
}})
class GoogleMap extends Vue {
  
  @Prop() loadingDevices: boolean;
  @Prop() current_device: object;
  @Prop() is_device_info_open: boolean;
  @Prop() devices: [];
  @Prop() filter: object;
  @Prop() lang: string;
  @Prop() infoFromMapview: string;
  @Prop() showSelectionTools: boolean;
  @Prop() group: boolean;
  @Prop() groupDevices;
  @Prop() dragOnly: boolean;
  @Prop() unassigned: boolean;
  @Prop() searchClicked: boolean;
  @Prop() tab: string;
  @Prop() setSearchClicked: (clicked: boolean) => void;
  @Prop() clearDeviceData: () => void;
  @Prop() fullMap: boolean;
  @Prop() setIsFullMap: (is_full_map: boolean) => void;

    mqtt = MQTT.instance;
    cabinet_circuits = new Map();
    cabinet_connected_percent = new Map();
    confirmDragDialog = false;
    map_layers = new Map();
    isDefaultCabinet = false;
    dragPrevLocation = {lat: null, lng: null};
    dragCurrentLocation = {lat: null, lng: null};
    dragMarker = null;
    dragStarted = false;
    dragFeature = null;
    draggableFeatures = new Map();
    // cabinets: new Map(),
    // cabinet_ids: [],
    // cabinets_devices: new Map(),
    // fullviewPage: false,
    markers_map = new Map();
    __iconCache: any = null;
    __sizeCache: any = null;
    __missingIconWarned: any = null;
    __boundsFit = false;
    __unwatchStreaming: any = null;
    __cabinetByIdForMarkers: any = null;
    __markerInfoTimer: any = null;
    __renderedOnce = false;
    __markerInfoRunning = false;
    __markerInfoPending = false;
    map = null;
    cabinetPage = false;
    showAdvancedLocations = false;
    tommorow = null;
    yesterday = null;
    today_00 = null;
    today_23 = null;
    search_value = '';
    showLegend = true;
    center = { lat: 32.08816963237704, lng: 34.79698850793454 };
    markers = [];
    mapStyles = {};
    device = null;
    boundsOptions = {
      padding: 65,
      screenSpeed: 8
    };
    infoPositionCurrent = null;
    infoOpenedCurrent = null;
    infoContentCurrent = null;
    infoOptionsCurrent = {
      disableAutoPan: true,
      pixelOffset: {
        width: 0,
        height: -35
      },
      zIndex: -10000
    };
    hasCustomMapStyles = false;
    styleList = defaultStyleSheet;
    customMapStyles = {};
    mapMode = 'defaultMode';
    wrapStyles = { 'border-radius': '20px', 'outline': 'none !important' };
    openSearch = false;
    showSettings = false;
    apiKey = config.TOKEN_GOOGLE;
    mapOptions = {
      disableDefaultUI: true,
      scaleControl: true,
      zoomControl: true,
      fullscreenControl: true,
      styles: mapStyles.defaultMode,
      maxZoom: mapMaxZoom,
      minZoom: mapMinZoom
    };
    showCircuitNumbers = false;
    isSatelliteMap = false;
    showHeatMap = false;
    redHeatMap = null;
    redHeatMapPoints = [];
    yellowHeatMap = null;
    yellowHeatMapPoints = [];
    greenHeatMap = null;
    greenHeatMapPoints = [];
    gradientGreen = [
      'rgba(139,255,82,0)',
      'rgba(139,255,22,1)',
      'rgba(139,255,22,1)',
      'rgba(139,255,22,1)',
      'rgba(139,255,22,1)'
    ];
    gradientYellow = [
      'rgba(139,255,82,0)',
      'rgba(239,250,1, 1)',
      'rgba(239,250,1, 1)',
      'rgba(239,250,1, 1)',
      'rgba(239,250,1, 1)'
    ];
    gradientRed = [
      'rgba(209, 0, 0, 0)',
      'rgba(229, 0, 0, 1)',
      'rgba(229, 0, 0, 1)',
      'rgba(229, 0, 0, 1)',
      'rgba(229, 0, 0, 1)'
    ];
    location = null;
    projectName = null;
    advancedLocations = {markers: false, gps: false, gis: false, app: false};
    polygonLocations = [];
    polygonMarkers = [];
    polygon = null;
    polyline = null;
    polyline1 = null;
    polyline2 = null;
    polygonDevices = [];
    mapCurrentBounds = { hiLat: 0, loLat: 0, hiLng: 0, loLng: 0 }; // highLat lowLat highLng lowLng
    map_layers_listeners = new Map();
    deviceSelectorChecked = false;
    $gmapApiPromiseLazy!: () => Promise<any>;
    $refs!: { 
      propEditor: InstanceType<typeof PropEditor>,
      map: GmapMapRef
    };
  
    get google() { return gmapApi(); }

    get readonly_user() {
      return this.$store.state.Global.readonly_user;
    }

    get day_of_week(){
      return this.$store.state.Global.day_of_week;
    }

    get projectDefaultLocation(){
      return this.$store.state.Props.project_default_location;
    }

    get displayFullMapBtn() {
      return this.$route.path === '/' && !this.current_device && !this.searchClicked && !this.group;
    }

    // Live progress for the loader overlay. Reads two already-reactive Vuex
    // values — no extra cost beyond a single property read per batch commit.
    get loadingLoaded(): number {
      return this.$store.state.Reports.reportsList.length;
    }

    get loadingTotal(): number {
      const count = this.$store.state.Reports.devicesCount;
      return count > 0 ? count : 0;
    }

    get loadingProgressPercent(): number {
      if (!this.loadingTotal) return 0;
      // Clamp to 99 while streaming — 100% is reserved for the moment the
      // loader actually hides, so the user never sees 100% sitting on screen.
      const pct = Math.floor((this.loadingLoaded / this.loadingTotal) * 100);
      return Math.min(99, Math.max(0, pct));
    }

    get isMobile() {
      return this.$store.state.Global.isMobile;
    }

    get filteredDevicesRoute(){
      return this.$route.path.includes('/filter/create') 
        || this.$route.path.includes('custom') 
        || this.$route.path.includes('cabinet-details')
        || this.$route.path.includes('monitoring_report')
        || this.$route.params.cid
        || this.tab && this.tab.includes('multiple-search');
    }

    get deviceDrag() {
      return this.$store.state.MapSettings.deviceDrag;
    }

    get mapHeight(){
      return this.$route.path.includes('monitoring_report') 
        ? 'map-height-install-report' 
        : this.$route.path.includes('cabinet-details')
          ? 'map-height-cabinet-page'
          : this.fullMap
            ? 'map-height-full'
            : this.$route.path.includes('/groups')
              ? 'map-height-group'
              : this.current_device && this.isMobile
                ? 'map-height-device-and-mobile'
                : 'map-height-project-info';
    }

    get projectProperties() {
      return this.$store.state.Props.list;
    }


    // heatPoints() {
    //   if (this.markers.length < 1) return [];

    //   const heatmap_points = [];
    //   this.markers.forEach((marker) => {
    //     const heat_point = {lat: marker['meta.location'].lat, lng: marker['meta.location'].lng, weight: null};
    //     heat_point.weight = marker.rssi ? marker.rssi : marker.rssi === 0 ? 0 : null;
    //     heatmap_points.push(heat_point);
    //   });
    //   return heatmap_points;
    // }

  beforeMount() {
    this.location = this.$route.path;
    this.projectName = this.$store.state.User.project.name;
    this.$store.commit('MapSettings/setDeviceRepositioning', false);
  }

  beforeDestroy(){
    if (this.__unwatchStreaming) {
      this.__unwatchStreaming();
      this.__unwatchStreaming = null;
    }
    if (this.__markerInfoTimer) {
      clearTimeout(this.__markerInfoTimer);
      this.__markerInfoTimer = null;
    }
    this.removeMapLayersListeners();
    this.map = null;
    if (this.mqtt && !this.$route.path.includes('cabinet-details')) {
      this.mqtt.clearListeners();
    }
  }

  mounted() {
    this.mqtt.listenToProjectEvents();
    this.$root.$refs.GoogleMap = this;
    this.cabinetPage = this.$route.path.includes('cabinet-details');
    // this.fullviewPage = this.$route.path === '/';
    this.setDatesInfo();
    this.initSearch();
    this.getProjectMapStyles();
    this.setMapResize();
    this.setMapBounds([]);
    // Warm the browser's image cache for every icon up front. Without this, Google
    // Maps renders a grey placeholder for each marker until its icon image is
    // fetched & decoded — which is very visible on first render with thousands of
    // features competing for the network. Preloading is fire-and-forget; the
    // browser caches the responses and subsequent <img>/Icon requests resolve
    // instantly from cache.
    this.preloadAllIcons();

    // Once ALL streaming endpoints (cabinets / fixtures / rest) finish, fit the
    // map to all loaded devices exactly once. This gives a final, complete view
    // without reframing mid-stream on every batch (which felt like a random
    // auto-zoom to the user). Uses $store.watch so we don't need to add a
    // dedicated prop just for this signal.
    this.__unwatchStreaming = this.$store.watch(
      (state) => state.Reports.streamingComplete,
      (val) => {
        if (!val || !this.map) return;
        // Use `this.devices` rather than `markers_map`: the chunked feature-add
        // (rAF-throttled, 200 per frame) may still be mid-flight when
        // streamingComplete flips, so markers_map can lag the full set.
        // `this.devices` is the authoritative full list from the store.
        const commissioned_map = this.$store.getters['Reports/commissioned_map'];
        const all = this.devices.filter((d: any) =>
          d.has_valid_location && commissioned_map.has(d.id)
        );
        if (!all.length) return;
        this.setMapBounds(all);
        this.__boundsFit = true;
      }
    );
  }

  preloadAllIcons() {
    try {
      const urls: string[] = Object.values(config.icons || {}) as string[];
      const seen = new Set<string>();
      urls.forEach((url) => {
        if (!url || seen.has(url)) return;
        seen.add(url);
        const img = new Image();
        // decoding=async + low fetchpriority keep this off the critical path so
        // it doesn't compete with the streaming network requests.
        (img as any).decoding = 'async';
        (img as any).fetchPriority = 'low';
        img.src = url;
      });
    } catch (e) {
      // Preloading is purely an optimization; never block the map on it.
      console.warn('preloadAllIcons failed', e);
    }
  }

  setMapLayers(){
    this.setDataMapLayer('markers');
    this.setDataMapLayer('gps');
    this.setDataMapLayer('gis');
    this.setDataMapLayer('app');
  }

  setDatesInfo() {
    this.yesterday = moment(+localStorage.getItem('now')).subtract(1, 'days').valueOf();
    this.tommorow = moment(+localStorage.getItem('now')).add(1, 'days').valueOf();
    this.today_00 = moment(+localStorage.getItem('now')).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).valueOf();
    this.today_23 = moment(+localStorage.getItem('now')).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }).valueOf();
  }

  showHeatMaps(value) {
    this.redHeatMap.setMap(value);
    this.yellowHeatMap.setMap(value);
    this.greenHeatMap.setMap(value);
  }

  setAdvancedLocationsIsOpen() {
    if (this.showSettings) this.showSettings = false;
    this.showAdvancedLocations = !this.showAdvancedLocations;
    if (!this.showAdvancedLocations){
      this.clearPolylines();
      this.clearAdvancedLocations();
    }
  }

  clearAdvancedLocations(){
    if (!this.advancedLocations.markers) {
      Vue.set(this.advancedLocations, 'markers', true);
      this.map_layers.get('markers').setMap(this.map);
    }
    if (this.advancedLocations.gps){
      Vue.set(this.advancedLocations, 'gps', false);
      this.map_layers.get('gps').setMap(null);
    }
    if (this.advancedLocations.gis){
      Vue.set(this.advancedLocations, 'gis', false);
      this.map_layers.get('gis').setMap(null);
    }
    if (this.advancedLocations.app){
      Vue.set(this.advancedLocations, 'app', false);
      this.map_layers.get('app').setMap(null);
    }
  }
    // generateHeatmapLayers(){
    //   this.$nextTick(() => {
    //     this.$refs.map.$mapPromise.then(() => {
    //       const self = this;
    //       try {
    //         this.heatPoints.forEach((coord) => {
    //           if (coord.weight === null) return null;
    //           if (coord.weight < -100) {
    //             this.redHeatMapPoints.push(new google.maps.LatLng(coord.lat, coord.lng));
    //           } else if (coord.weight < -80) {
    //             this.yellowHeatMapPoints.push(new google.maps.LatLng(coord.lat, coord.lng));
    //           } else {
    //             this.greenHeatMapPoints.push(new google.maps.LatLng(coord.lat, coord.lng));
    //           }
    //         });
    //         this.redHeatMap = this.createHeatMapLayer(this.redHeatMapPoints, this.gradientRed, self);
    //         this.yellowHeatMap = this.createHeatMapLayer(this.yellowHeatMapPoints, this.gradientYellow, self);
    //         this.greenHeatMap = this.createHeatMapLayer(this.greenHeatMapPoints, this.gradientGreen, self);
    //       } catch (error) {
    //         console.log(error);
    //       }
    //     });
    //   });
    // },
    toggleHeatMap() {
      this.showHeatMap = !this.showHeatMap;
      this.showHeatMap ? this.showHeatMaps(this.map) : this.showHeatMaps(null);
    }

    createHeatMapLayer(data, gradient, self){
      return new google.maps.visualization.HeatmapLayer({
        data,
        map: self.$refs.map.$mapObject,
        radius: 30,
        gradient,
        maxIntensity: 3
      });
    }

    toggleCircuitNumbers() {
      this.showCircuitNumbers = !this.showCircuitNumbers;
      // Iterate over actual map features to avoid race conditions with markers array
      this.map_layers.get('markers').forEach((feature) => {
        const marker = this.markers_map.get(feature.getId());
        if (marker) {
          this.updateFeatureIcon(marker);
        }
      });
    }

    toggleSatelliteMap() {
      if (this.showSettings) this.showSettings = false;
      this.isSatelliteMap = !this.isSatelliteMap;
      if (this.isSatelliteMap) {
        this.$refs.map.$mapObject.setMapTypeId('hybrid');
      } else {
        this.$refs.map.$mapObject.setMapTypeId('roadmap');
      }
    }

    refreshMap() {
      this.$refs.map.$mapObject.setMapTypeId('hybrid');
    }

    setMapResize() {
      // Debounce: the sidebar's CSS transition mutates the map-container's attributes ~60x
      // over its 300ms animation. Triggering google.maps `resize` on each tick causes a
      // full re-layout of every feature on every frame -> visible delay when toggling
      // the sidebar with thousands of markers. Schedule a single resize after the
      // mutations settle.
      let timer: any = null;
      const observer = new MutationObserver((m) => {
        if (timer) clearTimeout(timer);
        const target = m[0].target;
        timer = setTimeout(() => {
          this.setMapStyle('height', target['clientHeight'] + 'px');
          if (this.map && typeof google !== 'undefined' && google.maps) {
            google.maps.event.trigger(this.map, 'resize');
          }
          timer = null;
        }, 150);
      });
      const child = document.getElementsByClassName('map-container')[0];
      observer.observe(child, { attributes: true });
    }

    smoothZoom(level, cnt) {
      if (cnt >= level) {
        return;
      } else {
        const z = this.map.addListener('zoom_changed', (e) => {
          google.maps.event.removeListener(z);
          this.smoothZoom(level, cnt + 1);
        });
        setTimeout(() => {
          this.map.setZoom(cnt);
        }, 80);
      }
    }

    updateDeviceSelectorData() {
      if (this.showAdvancedLocations) this.setAdvancedLocationsIsOpen();
      if (this.deviceSelectorChecked) {
        this.clearDeviceSelector();
        return;
      }
      this.deviceSelectorChecked = true;
      this.$emit('chooseDevicesSelected', true);
    }

    clearDeviceSelector(){
      this.deviceSelectorChecked = false;
      this.clearPolySelection();
      if (!this.$route.path.includes('/groups/')){
        this.$emit('chooseDevicesSelected', false);
        this.$emit('selectedChanged', this.groupDevices && this.groupDevices.size ? [...this.groupDevices.values()] : []);
      }
    }

    setIsSelectorChecked(){
      if (this.deviceSelectorChecked) {
        this.deviceSelectorChecked = false;
        this.clearPolySelection();
        return;
      }
      this.deviceSelectorChecked = true;
    }

    getMarkerOptions(marker, layer) {
      let icon, metaDevice, final_marker = null;
      try {
        if (marker['meta.device']){
          metaDevice = marker['meta.device'];
          final_marker = marker;
        }else {
          final_marker = this.$store.getters['Reports/commissioned_map'].get(marker.id);
          metaDevice = final_marker['meta.device'];
        }
        icon = this.calculateMarkerIcon(final_marker);
      } catch (e) {
        console.warn('error getting icon', e);
      }
      return {
        icon
      };
    }

    getCabinetPageMarkerOptions(marker) {
      let icon, circuit_number;
      try {
        const metaDevice = marker['meta.device'];
        circuit_number = Utils.hasTondoClass(marker['meta.category'].category)
          ? metaDevice.circuit_number
          : '';

        icon = this.calculateMarkerIcon(marker);
      } catch (e) {
        icon = '';
        circuit_number = '';
        console.log(`no circuit_number for ${marker.id}`);
      }

      return {
        icon,
        label:
          (this.showCircuitNumbers && circuit_number && {
            color: '#DA0AAA',
            fontWeight: 'bold',
            fontSize: '14px',
            text: circuit_number.toString()
          }) ||
          ''
      };
    }

    calculateMarkerIcon(device) {
      const isSelected = this.group &&
                         this.groupDevices &&
                         this.groupDevices.size &&
                         this.groupDevices.has(device.id);
      // Selected variants are computed on demand for the (small) selected subset.
      // Unselected devices use the pre-computed __iconKey stashed at commit/update time.
      const iconKey = isSelected
        ? getMapIcon(device, true)
        : (device.__iconKey || getMapIcon(device, false));
      return this.getOrBuildIcon(iconKey, 18);
    }

    // Returns the same google.maps.Icon object reference for identical (key, size)
    // pairs across the entire map. With ~28k features but only ~30 distinct icon
    // keys, this turns thousands of Icon allocations into a handful and lets
    // Google Maps' internal caches dedupe icon image rendering. After
    // primeIconCache() runs, this is effectively a pure cache lookup.
    getOrBuildIcon(iconKey, size){
      if (!this.__iconCache) this.__iconCache = new Map();
      if (!this.__sizeCache) this.__sizeCache = new Map();
      const cacheKey = `${iconKey}|${size}`;
      let icon = this.__iconCache.get(cacheKey);
      if (icon) return icon;
      const url = config.icons[iconKey];
      if (!url) {
        // Unknown iconKey — Google Maps would render its default red pin for
        // this feature. Warn once per missing key to make it obvious.
        if (!this.__missingIconWarned) this.__missingIconWarned = new Set();
        if (!this.__missingIconWarned.has(iconKey)) {
          this.__missingIconWarned.add(iconKey);
          console.warn(`[GMap] No icon configured for key "${iconKey}" — falling back to defaultMarker`);
        }
        // Use the configured default marker so we never hand back a broken Icon.
        const fallbackUrl = config.icons.defaultMarker;
        icon = { url: fallbackUrl, scaledSize: this.getOrBuildSize(size) };
      } else {
        icon = { url, scaledSize: this.getOrBuildSize(size) };
      }
      this.__iconCache.set(cacheKey, icon);
      return icon;
    }

    getOrBuildSize(size){
      if (!this.__sizeCache) this.__sizeCache = new Map();
      let scaledSize = this.__sizeCache.get(size);
      if (!scaledSize) {
        scaledSize = new google.maps.Size(size, size);
        this.__sizeCache.set(size, scaledSize);
      }
      return scaledSize;
    }

    // Eagerly build google.maps.Icon objects for every key in config.icons at
    // the standard marker size (18). Circle layers (gps/gis/app) use distinct
    // sizes (24/28/32) which getOrBuildIcon will lazily add on first request.
    // Building Icon objects up front means no allocation happens during the
    // initial bulk render of thousands of features — every call is a cache hit.
    primeIconCache() {
      try {
        if (!this.__iconCache) this.__iconCache = new Map();
        if (!this.__sizeCache) this.__sizeCache = new Map();
        const markerSize = 18;
        const scaledSize = this.getOrBuildSize(markerSize);
        const keys = Object.keys(config.icons || {});
        keys.forEach((key) => {
          const url = (config.icons as any)[key];
          if (!url) return;
          const cacheKey = `${key}|${markerSize}`;
          if (!this.__iconCache.has(cacheKey)) {
            this.__iconCache.set(cacheKey, { url, scaledSize });
          }
        });
        // Also pre-build the three circle sizes used by addCircleFeature.
        ['gpsCircle|24', 'gisCircle|28', 'appCircle|32'].forEach((cacheKey) => {
          const [key, sizeStr] = cacheKey.split('|');
          const url = (config.icons as any)[key];
          if (!url) return;
          if (!this.__iconCache.has(cacheKey)) {
            this.__iconCache.set(cacheKey, { url, scaledSize: this.getOrBuildSize(+sizeStr) });
          }
        });
      } catch (e) {
        console.warn('primeIconCache failed', e);
      }
    }

    overrideFeaturesStyle(layer_name){
      try {
        this.map_layers.get('markers').forEach((feature) => {
          try {
            const featureId = feature.getId();
            const marker = this.markers_map.get(featureId);
            
            if (!marker) {
              console.warn(`Marker not found for feature ID: ${featureId}`);
              return;
            }
            
            const options = this.getMarkerOptions(marker, 'advanced');
            // Same safety net as updateFeatureIcon: never apply an undefined icon,
            // it would make the marker invisible. Keep whatever icon the feature
            // already has if computation failed.
            if (!options || !options.icon) return;
            this.map_layers.get('markers').overrideStyle(feature, { icon: options.icon });
          } catch (featureError) {
            console.error(`Error processing feature in 'advanced' mode:`, featureError);
            console.error('Feature ID:', feature ? feature.getId() : 'unknown');
          }
        });
        this.map_layers.get('markers').setMap(this.map);
      } catch (error) {
        console.error(`Error in overrideFeaturesStyle for layer: ${layer_name}`, error);
      }
    }
    
    clearMapData(){
      if (this.filteredDevicesRoute) {
        this.removeAllLayerFeatures('markers');
        this.markers_map = new Map();
        this.markers = [];
        // The set of devices is genuinely changing — allow setMapBounds to refit
        // to the new context (e.g. cabinet view, filter view) on the next render.
        this.__boundsFit = false;
      }
      this.isDefaultCabinet = false;
      this.showAdvancedLocations = false;

      this.clearPolylines();
      this.clearAdvancedLocations();
    }
    
    getCommissionedDevices(){
      let commissioned = this.getInstalledWithValidLocation();
      if (this.unassigned){
        this.isDefaultCabinet = true;
        commissioned = commissioned.filter((device) => this.isMarkerInsideMapBounds(device));
      }
      return commissioned;
    }
    
    setMarkerInformation() {
      // Reentrancy guard: setMarkersMapData is async (chunked rAF). If a second call
      // arrives while the first is still mid-flight (e.g. late batches firing the
      // devices watcher), skip it but remember to run once after the current run
      // finishes so we don't lose the latest data.
      if (this.__markerInfoRunning) {
        this.__markerInfoPending = true;
        return;
      }
      this.__markerInfoRunning = true;
      this.setMapLayers();
      this.clearMapData();
      // Attach styles/listeners and put the layer on the map BEFORE adding features,
      // so features render progressively as they're added (no gray map / no big main-thread block).
      this.setMapLayersStyles();
      this.setMapLayersListeners();
      this.map_layers.get('markers').setMap(this.map);
      // Fit bounds BEFORE adding features so the map starts at the correct zoom/center
      // immediately. Without this the user sees default-zoom partial markers, then a
      // visible "jump" once all features have been added.
      //
      // IMPORTANT: only do this on the FIRST render. Subsequent re-runs (caused by
      // late-arriving streamed devices firing the devices watcher) pass only the
      // *new* devices to setMapBounds, which would otherwise reframe the map onto
      // an arbitrary subset — exactly the "map zoomed in by itself" behavior.
      // The user's pan/zoom is sacred after the first fit.
      if (!this.__boundsFit) {
        const commissionedForBounds = this.getCommissionedDevices();
        if (commissionedForBounds.length && this.cabinetPage && !this.unassigned || !this.cabinetPage) {
          this.setMapBounds(commissionedForBounds);
          if (commissionedForBounds.length) this.__boundsFit = true;
        }
      }
      this.setMarkersMapData().then(() => {
        this.markers = [...this.markers_map.values()];
        this.__markerInfoRunning = false;
        if (this.__markerInfoPending) {
          this.__markerInfoPending = false;
          // Re-run once with the latest data; clear any pending debounce.
          if (this.__markerInfoTimer) {
            clearTimeout(this.__markerInfoTimer);
            this.__markerInfoTimer = null;
          }
          this.setMarkerInformation();
        }
      });
    }
    
    setMapLayersStyles(){
      this.addDataLayerStyles(this.map_layers.get('markers'), 2);
      this.addDataLayerStyles(this.map_layers.get('gps'), 1);
      this.addDataLayerStyles(this.map_layers.get('gis'), 1);
      this.addDataLayerStyles(this.map_layers.get('app'), 1);
    }
    
    setMapLayersListeners(){
      this.addDataLayerListeners(this.map_layers.get('markers'), 'markers');
    }
    
    removeMapLayersListeners(){
      this.removeLayerListener(this.map_layers.get('markers'), 'markers');
    }
    
    removeLayerListener(layer, layer_name){
      if (typeof google === 'undefined' || !google.maps || !google.maps.event) {
        return;
      }
      if (this.checkLayerHasListener(layer, layer_name, 'click')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_click`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mouseup')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mouseup`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mousedown')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mousedown`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mouseout')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mouseout`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mouseover')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mouseover`));
      }
      this.map_layers_listeners = new Map();
    }
    
    checkLayerHasListener(layer, layer_name, event_name){
      if (typeof google === 'undefined' || !google.maps || !google.maps.event) {
        return false;
      }
      return google.maps.event.hasListeners(layer, event_name) &&
        this.map_layers_listeners.has(`${layer_name}_${event_name}`) &&
        this.map_layers_listeners.get(`${layer_name}_${event_name}`);
    } 

    async setMarkersMapData(){
      const commissioned = this.getCommissionedDevices();
      const layer = this.map_layers.get('markers');
      // Build cabinet_id → cabinet lookup ONCE for this entire pass. Used to populate
      // __iconKey for any device whose icon hasn't been pre-computed yet (e.g. when the
      // map is opened before the post-stream `_recomputeAllIcons` mutation runs).
      const cabinetById = buildCabinetByIdMap();
      this.__cabinetByIdForMarkers = cabinetById;
      // Chunked add with an rAF yield between chunks. Smaller chunks mean
      // the first batch of markers paints sooner (better perceived speed at
      // the end of streaming when the loader sits at 'Rendering map…') at
      // the cost of slightly more rAF overhead. 1000 strikes a good balance
      // — well below the Chrome long-task threshold, ~3–4 frames total for
      // a 28k device project.
      const CHUNK = 1000;
      for (let i = 0; i < commissioned.length; i += CHUNK) {
        const end = Math.min(i + CHUNK, commissioned.length);
        for (let j = i; j < end; j++) {
          const marker: any = commissioned[j];
          if (!marker.__iconKey) {
            try { marker.__iconKey = getMapIcon(marker, false, cabinetById); } catch (e) { /* skip */ }
          }
          this.setExtraDeviceData(marker);
          this.addFeature(marker, layer, 'advanced');
          this.markers_map.set(marker['id'], marker);
        }
        if (end < commissioned.length) {
          await new Promise((r) => requestAnimationFrame(() => r(undefined)));
        }
      }
      // Drop the per-pass lookup once all markers are added to release the cabinet refs.
      this.__cabinetByIdForMarkers = null;
    }

    setExtraDeviceData(marker){
      if (Utils.hasTondoClass(marker['meta.category'].category)) {
        this.setExtraFixtureData(marker);
      } else if (Utils.hasFloodSensorClass(marker['meta.category'].category)){
        this.setExtraFloodSensorData(marker);
      }
    }

    setExtraFixtureData(marker){
      if (marker.hasOwnProperty('meta.install_location') && marker['meta.install_location']) this.setInstallLocationData(marker);
    }

    setExtraFloodSensorData(marker){
      marker[FloodSensor.BOTTOM_FLOAT_TRIGGER] = !marker.hasOwnProperty(FloodSensor.BOTTOM_FLOAT_TRIGGER) ? 0 : +marker[FloodSensor.BOTTOM_FLOAT_TRIGGER];
      marker[FloodSensor.TOP_FLOAT_TRIGGER] = !marker.hasOwnProperty(FloodSensor.TOP_FLOAT_TRIGGER) ? 0 : +marker[FloodSensor.TOP_FLOAT_TRIGGER];
      marker[FloodSensor.ULRASONIC_SENSOR_TRIGGER] = !marker.hasOwnProperty(FloodSensor.ULRASONIC_SENSOR_TRIGGER) ? 0 : +marker[FloodSensor.ULRASONIC_SENSOR_TRIGGER];
    }

    setDataMapLayer(name){
      if (this.map_layers.has(name)) {
        return;
      }
      const layer = new google.maps.Data();
      this.map_layers.set(name, layer);
    }

    setInstallLocationData(marker){
      let install_location_prop = marker['meta.install_location'];
      if (!install_location_prop || typeof install_location_prop !== 'object'){
        install_location_prop = {
          gps_location: { lat: '', lng: '' },
          app_location: { lat: '', lng: '' },
          gis_location: { lat: '', lng: '' },
          manual_location: { lat: '', lng: '' }
        };
        marker['meta.install_location'] = install_location_prop;
      }

      if (install_location_prop.hasOwnProperty('gps_location') && Utils.isValidLocation(install_location_prop['gps_location'])){
        const coords = {lat: parseFloat(install_location_prop['gps_location'].lat), lng: parseFloat(install_location_prop['gps_location'].lng)};
        this.addCircleFeature(`gps_${marker.id}`, coords, 'gpsCircle', 24, 'gps');
      }
      if (install_location_prop.hasOwnProperty('gis_location') && Utils.isValidLocation(install_location_prop['gis_location'])){
        const coords = {lat: parseFloat(install_location_prop['gis_location'].lat), lng: parseFloat(install_location_prop['gis_location'].lng)};
        this.addCircleFeature(`gis_${marker.id}`, coords, 'gisCircle', 28, 'gis');
      }
      if (install_location_prop.hasOwnProperty('app_location') && Utils.isValidLocation(install_location_prop['app_location'])){
        const coords = {lat: parseFloat(install_location_prop['app_location'].lat), lng: parseFloat(install_location_prop['app_location'].lng)};
        this.addCircleFeature(`app_${marker.id}`, coords, 'appCircle', 32, 'app');
      }
    }

    addCircleFeature(id, coordinates, circle_name, icon_size, layer_name){
      // The icon MUST be present on the feature at construction time. If we
      // added the feature first and applied the icon via overrideStyle after,
      // Google Maps would render its default red pin during the (very brief)
      // gap between add() and overrideStyle() — visible as "jumping red icons"
      // during the bulk render of thousands of features.
      const icon = this.getOrBuildIcon(circle_name, icon_size);
      const feature = new google.maps.Data.Feature({
        id,
        geometry: new google.maps.Data.Point({...coordinates}),
        properties: { icon }
      });
      this.map_layers.get(layer_name).add(feature);
    }

    addFeature(marker, layer, layer_name){
      const options = this.cabinetPage && this.getCabinetPageMarkerOptions(marker) || this.getMarkerOptions(marker, layer_name);
      // The icon (and label, if applicable) are stored on the feature itself so
      // they're present at the moment of layer.add() — no flash to the default
      // red pin. The per-feature style function in addDataLayerStyles reads
      // these properties; the Icon objects are reference-equal across features
      // thanks to getOrBuildIcon's cache.
      const properties: any = { icon: options.icon };
      if (this.cabinetPage && !this.isDefaultCabinet) properties.label = options['label'];
      const feature = new google.maps.Data.Feature({
        id: marker.id,
        geometry: new google.maps.Data.Point({lat: marker['meta.location'].lat, lng: marker['meta.location'].lng}),
        properties
      });
      layer.add(feature);
    }

    addDataLayerStyles(layer, zIndex){
      // Per-feature style function that just reads from the feature's properties.
      // We can't use a static StyleOptions object here because the icon (and
      // optional label) varies per feature, and overrideStyle-after-add caused
      // visible default-pin flicker. The function is cheap — it allocates one
      // small object per call and returns reference-cached Icon objects.
      layer.setStyle((feature) => {
        const styles: any = { icon: feature.getProperty('icon'), zIndex, draggable: false };
        const label = feature.getProperty('label');
        if (label !== undefined) styles.label = label;
        return styles;
      });
    }
    
    addDataLayerListeners(layer, layer_name){
      this.addClickEventToLayer(layer, layer_name);
      this.addMouseupEventToLayer(layer, layer_name);
      this.addMousedownEventToLayer(layer, layer_name);
      this.addMouseoverEventToLayer(layer, layer_name);
      this.addMouseoutEventToLayer(layer, layer_name);
    }
    
    addClickEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'click')) {
        const click_event = layer.addListener('click', (event) => {
          if (event.feature.getProperty('draggable')) this.setIsDraggable(event.feature, false);
          if (this.deviceDrag) this.toggleDragMarkers();
          if (this.showAdvancedLocations) this.setAdvancedLocationsIsOpen();
          this.clickMarker(this.markers_map.get(event.feature.getId()));
        });
        this.map_layers_listeners.set(`${layer_name}_click`, click_event);
      }
    }

    addMouseupEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mouseup')){
        const mouseup_event = layer.addListener('mouseup', (event) => {
        if (this.deviceDrag) {
          const point = event.feature.getGeometry();
          this.dragCurrentLocation = {lat: point.get().lat(), lng: point.get().lng()};
          if (!isEqual(this.dragPrevLocation, this.dragCurrentLocation)){
            this.dragOnly && !this.$route.path.includes('virtual-devices')
              ? this.$emit('dragend', this.dragMarker, this.dragCurrentLocation, this.dragPrevLocation)
              : this.confirmDragDialog = true;
          }
        }
        });
        this.map_layers_listeners.set(`${layer_name}_mouseup`, mouseup_event);  
      }
    }

    addMousedownEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mousedown')){
        const mousedown_event = layer.addListener('mousedown', (event) => {
          if (this.deviceDrag) {
            if (this.infoOpenedCurrent) this.closeInfoWindow();
            this.dragMarker = this.markers_map.get(event.feature.getId());
            const point = event.feature.getGeometry();
            this.dragPrevLocation.lat = point.get().lat();
            this.dragPrevLocation.lng = point.get().lng();
          }
        });
        this.map_layers_listeners.set(`${layer_name}_mousedown`, mousedown_event);
      }
    }

    addMouseoverEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mouseover')){
        const mouseover_event = layer.addListener('mouseover', (event) => {
          if (this.deviceDrag && !this.draggableFeatures.has(event.feature.getId())) {
            this.setIsDraggable(event.feature, true);
            this.draggableFeatures.set(event.feature.getId(), true);
          }
          if (!this.current_device && this.showAdvancedLocations){
            this.addPolylines(this.markers_map.get(event.feature.getId()));
          }else if (!this.current_device && !this.showAdvancedLocations && !this.dragMarker) {
            this.showCurrentInfoWindow(this.markers_map.get(event.feature.getId()));
          }
        });
        this.map_layers_listeners.set(`${layer_name}_mouseover`, mouseover_event);
      }
    }

    addMouseoutEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mouseout')){
        const mouseout_event = layer.addListener('mouseout', (event) => {
          if (!this.current_device && this.showAdvancedLocations) this.clearPolylines();
          if (!this.current_device && !this.showAdvancedLocations) this.closeInfoWindow();
        });
        this.map_layers_listeners.set(`${layer_name}_mouseout`, mouseout_event);
      }
    }

    setIsDraggable(feature, draggable) {
      try {
        // overrideStyle merges with existing overrides, so we only need to set the
        // bit that's actually changing. icon / label / zIndex stay as they were.
        this.map_layers.get('markers').overrideStyle(feature, { draggable });
      } catch (error) {
        console.warn(`setIsDraggable Error processing ${feature ? feature.getId() : 'unknown'} `);
      }
    }

    updateFeatureIcon(marker) {
      this.$nextTick(() => {
        try {
          // Check if marker exists in the current markers_map before attempting to update
          if (!this.markers_map.has(marker.id)) {
            console.debug(`Marker ${marker.id} not in current map view, skipping icon update`);
            return;
          }

          const feature = this.map_layers.get('markers').getFeatureById(marker.id);
          if (!feature) {
            console.warn(`Feature not found for marker ID: ${marker.id}`);
            return;
          }
          const layer_name = 'advanced';
          const options = this.cabinetPage && this.getCabinetPageMarkerOptions(marker) || this.getMarkerOptions(marker, layer_name);
          // Critical: if icon computation failed (e.g. the device is briefly missing
          // from commissioned_map during an MQTT update), do NOT call overrideStyle
          // with an undefined icon — that would make the marker invisible. Skip
          // the update and let the existing icon remain.
          if (!options || !options.icon) {
            console.warn(`updateFeatureIcon: no icon computed for ${marker.id}, keeping existing icon`);
            return;
          }
          // Only update the dynamic bits. Pre-existing draggable / zIndex overrides
          // are preserved by overrideStyle's merge semantics.
          const overrides: any = { icon: options.icon };
          if (this.cabinetPage && !this.isDefaultCabinet) overrides.label = options['label'];
          this.map_layers.get('markers').overrideStyle(feature, overrides);
        } catch (error) {
          console.error(`Error updating feature icon for marker ID: ${marker?.id || 'unknown'}`, error);
        }
      });
    }

    closeInfoWindow(){
      this.closeWindow();
      if (!this.group && !this.dragOnly) this.clearDeviceData(); 
    }

    closeWindow(){
      this.infoPositionCurrent = null;
      this.infoOpenedCurrent = false;
      this.infoContentCurrent = null;
    }

    setMapBounds(locations) {
      if (locations && locations.length && this.$store.state.Global.deviceClicked) {
        this.clickExternalDevice(this.$store.state.Global.deviceClicked);
      } else {
        this.group && this.groupDevices && this.groupDevices.size
        ? this.setBounds([...this.groupDevices.values()])
        : this.setBounds(locations || []);
      }
    }

    clickExternalDevice(id){
      const marker = this.getMarkerById(id);
      if (marker) {
        this.setBounds([marker]);
      }
      this.clickMarker(marker);
    }

    getMarkerById(id){
      return this.markers_map.get(id);
    }

    getInstalledWithValidLocation() {
      // Cache the getter once outside the filter — `this.$store.getters['Reports/commissioned_map']`
      // goes through a Proxy on every access; reading it 28k times during the
      // filter is wasteful when the value is stable for the whole pass.
      const commissioned_map = this.$store.getters['Reports/commissioned_map'];
      const dragOnly = this.dragOnly;
      const cabinetPage = this.cabinetPage;
      return this.devices.filter((device: Device) => {
        if (this.markers_map.has(device.id)) return false;
        if ((!device.has_valid_location || !commissioned_map.has(device.id)) && !dragOnly) return false;
        if (!cabinetPage) return true;
        if (Utils.hasCabinetClass(device['meta.category'].category)) {
          const cabinet_id_value: string = device['meta.device'].cabinet_id;
          const cabinet_id = cabinet_id_value ? cabinet_id_value.toString() : '';
          if (cabinet_id === 'default') this.isDefaultCabinet = true;
        }
        return true;
      });
    }

    // getContainerMarker(device, container_id, coordinates) {
    //   return {
    //     id: device.id,
    //     container_id,
    //     class_name: 'CONTAINER',
    //     meta { 
    //      category: { category: 'CONTAINER' },
    //      location: { ...coordinates },
    //      device: device['meta.device'],
    //     }
    //   };
    // },
    clickMarker(marker) {
      if (!marker) return;
      
      if (this.showSelectionTools && this.deviceSelectorChecked || this.$route.path.includes('/groups/')) {
        this.$emit('markerClicked', [marker]);
        return;
      }

      if (Utils.hasCabinetClass(marker['meta.category'].category)) {
        this.$router.push(`/cabinet-details/${marker.id}`);
        return;
      }

      this.$emit('showDeviceInformation', marker);
      this.center = {lat: marker['meta.location'].lat, lng: marker['meta.location'].lng};
      this.setSearchClicked(false);
      setTimeout(() => this.showCurrentInfoWindow(marker), this.$store.state.Global.deviceClicked ? 500 : 0);
    }

    initSearch() {
      const input = document.getElementById('search-input') as HTMLInputElement;
      let tries = 0;
      const tryInit = () => {
        if (!this.$refs.map || !this.$refs.map.$mapPromise) {
          if (tries < 20) {
            tries += 1;
            setTimeout(tryInit, 50);
          }
          return;
        }

        this.$refs.map.$mapPromise.then((map) => {
          this.map = map;
          // Build google.maps.Icon objects for every key in config.icons up front.
          // Must run after the Maps API is ready (google.maps.Size requires it).
          // Once primed, getOrBuildIcon is a pure cache hit during render.
          this.primeIconCache();
          this.setMapLayers();
          this.whenMapReady();

          if (this.showSelectionTools) this.selectMarkersManager();
          Vue.set(this.mapOptions, 'zoomControlOptions', {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          });
          Vue.set(this.mapOptions, 'streetViewControl', {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          });
          if (input) {
            const searchBox = new window.google.maps.places.SearchBox(input);
            searchBox.addListener('places_changed', () => {
              const places = searchBox.getPlaces();
              if (places.length !== 0) {
                const location = places[0].geometry.location;
                const position = {
                  lat: location.lat(),
                  lng: location.lng()
                };
                map.panTo(position);
                this.smoothZoom(18, this.map.getZoom());
              }
            });
          }
          const thePanorama = this.map.getStreetView();
          thePanorama.addListener('visible_changed', () => {
            this.showLegend = !thePanorama.getVisible();
          });
          // if (this.fullviewPage){
          //   const zoom = map.addListener('zoom_changed', () => {
          //     const current_zoom = this.map.getZoom();
          //     if (current_zoom >= 15 && this.map_layers.get('cabinets_devices').getMap() === null){
          //       this.map_layers.get('cabinets_devices').setMap(this.map);
          //     }else if (current_zoom < 15 && this.map_layers.get('cabinets_devices').getMap() !== null){
          //       this.map_layers.get('cabinets_devices').setMap(null);
          //       if (this.$store.state.Global.deviceClicked) this.closeInfoWindow();
          //     }
          //   });
          // }
          
          // map.addListener('bounds_changed', async () => {
          //   await this.setMapCurrentBounds();
          // });
        });
      };

      this.$nextTick(() => {
        tryInit();
      });
    }

    // async setMapCurrentBounds(){
    //   const bounds = this.map.getBounds();
    //   if (bounds){
    //     const ne = bounds.getNorthEast();
    //     const sw = bounds.getSouthWest();
    //     if (ne.lat() && sw.lat() && ne.lng() && sw.lng()) {
    //       const hiLat = await ne.lat();
    //       const loLat = await sw.lat();
    //       const hiLng = await ne.lng();
    //       const loLng = await sw.lng();
    //       this.mapCurrentBounds = { hiLat, loLat, hiLng, loLng };
    //     }
    //   }
    // },
    drawPolygon(points) {
      if (points.length < 3) return;
      // first delete the previous polygon
      if (this.polygon) this.polygon.setMap(null);
      // @see https://developers.google.com/maps/documentation/javascript/examples/polygon-simple
      this.polygon = new google.maps.Polygon({
        paths: points,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        map: this.$refs.map.$mapObject
      });
      // display to input
      this.displaySelectedMarkers();
    }

    displaySelectedMarkers() {
      const poly = google && google.maps.geometry.poly;
      // @see https://developers.google.com/maps/documentation/javascript/examples/poly-containsLocation
      this.polygonDevices = this.markers.filter((marker) =>
        poly.containsLocation(new google.maps.LatLng(marker['meta.location'].lat, marker['meta.location'].lng), this.polygon)
      );
    }

    addDevices(state = false) {
      this.$emit('selectedChanged', this.polygonDevices, state);
      this.deviceSelectorChecked = false;
      this.clearPolySelection();
    }

    addSelectedDevices(state = null) {
      this.$emit('selectedChanged', this.polygonDevices, state);
      this.clearPolySelection();
    }

    clearPolySelection() {
      if (this.polygon) this.polygon.setMap(null);
      this.polygonMarkers.forEach((polygon_marker) => polygon_marker.setMap(null));
      this.polygonMarkers = [];
      this.polygonLocations = [];
      this.polygonDevices = [];
    }

    handleKeyPress(e){
      if (e.code === 'Delete' && this.deviceSelectorChecked && this.polygonDevices.length > 0) {
        this.deviceSelectorChecked = false;
        this.clearPolySelection();
      }
    }

    handleMapClick(e){
      if (this.deviceSelectorChecked) {
        const position = e.latLng;
        this.polygonLocations.push(position);
        this.polygonMarkers.push(
          new google.maps.Marker({
            icon: config.icons.measle,
            position,
            map: this.$refs.map.$mapObject
          })
        );
        this.drawPolygon(this.polygonLocations);
      }
    }

    selectMarkersManager() {
      if (google.maps.event.hasListeners(this.map, 'click')) return;

      document.addEventListener('keypress', this.handleKeyPress);
      this.map.addListener('click', this.handleMapClick);
    }

    isMarkerInsideMapBounds(marker){
      return this.$refs.map.$mapObject.getBounds().contains({lat: marker['meta.location'].lat, lng: marker['meta.location'].lng});
    }

    showCurrentInfoWindow(marker) {
      this.infoPositionCurrent = { lat: marker['meta.location'].lat, lng: marker['meta.location'].lng };
      this.infoContentCurrent = this.getMarkerText(marker);
      this.infoOpenedCurrent = true;
    }

    addPolylines(marker){
      this.clearPolylines();
      if (marker.hasOwnProperty('meta.install_location')) {
        const pathstart = [new google.maps.LatLng(marker['meta.location'].lat, marker['meta.location'].lng)];
        if (this.advancedLocations['gps']){
          const gps_feature = this.map_layers.get('gps').getFeatureById(`gps_${marker.id}`);
          if (gps_feature) this.setPolylinePath('polyline', 'green', gps_feature, pathstart);
        }
        if (this.advancedLocations['gis']){
          const gis_feature = this.map_layers.get('gis').getFeatureById(`gis_${marker.id}`);
          if (gis_feature) this.setPolylinePath('polyline1', 'red', gis_feature, pathstart);
        }
        if (this.advancedLocations['app']){
          const app_feature = this.map_layers.get('app').getFeatureById(`app_${marker.id}`);
          if (app_feature) this.setPolylinePath('polyline2', 'purple', app_feature, pathstart);
        }
      }
    }

    setPolylinePath(polyline, color, feature, pathstart){
      this[polyline] = this.createPolyline(color);
      const geometry = feature.getGeometry();
      const path = [...pathstart, new google.maps.LatLng(geometry.get().lat(), geometry.get().lng())];
      this[polyline].setPath(path);
      this[polyline].setMap(this.map);
    }

    createPolyline(strokeColor){
      return new google.maps.Polyline({
        strokeColor,
        strokeOpacity: 0.4
      });
    }

    getMarkerText(device) {
      const newDevice = deviceFactory.createDevice(device);
      return newDevice.getPopUpText();
    }

    setMarkerCoords(location, marker_id) {
      const marker = this.markers_map.get(marker_id);
      marker['meta.location'] = location;
    }

    setMapStyles(name) {
      if (this.hasCustomMapStyles) {
        const copy_map_styles = cloneDeep(this.customMapStyles);
        let defaultStyle = mapStyles['defaultMode'];
        Object.entries(copy_map_styles).forEach(([map_type, style]) => {
          style[0].default = this.mapMode === map_type;
          if (style[0].default) defaultStyle = style[0].style[0];
        });

        const prop = {
          name: 'dashboard.map_styles',
          objectID: this.$store.state.User.project.id,
          objectType: Types.PROJECTS
        };

        this.$refs.propEditor.save(
          copy_map_styles,
          prop,
          async () => {
            Object.entries(this.customMapStyles).forEach(([map_type, style]) => style[0].default = this.mapMode === map_type);
            // localStorage.setItem('mapMode', this.mapMode);
            Vue.set(this.mapOptions, 'styles', defaultStyle);
          },
          'Default style changed'
        );
      } else {
        // localStorage.setItem('mapMode', this.mapMode);
        Vue.set(this.mapOptions, 'styles', mapStyles[this.mapMode]);
      }
      this.toggleMapSettings();
    }

    setMapStyle(field_name, value) {
      Vue.set(this.mapStyles, field_name, value);
    }

    toggleSearch() {
      if (this.showSettings) this.showSettings = false;
      this.openSearch = !this.openSearch;
      this.search_value = '';
    }

    toggleMapSettings() {
      this.showSettings = !this.showSettings;
    }

    toggleDragMarkers() {
      if (this.showSettings) this.showSettings = false;
      this.$store.commit('MapSettings/setDeviceRepositioning', !this.deviceDrag );
      this.dragMarker = null;
      this.clearDragLocations();
      if (!this.deviceDrag){
        if (this.confirmDragDialog) this.confirmDragDialog = false;
        if (this.draggableFeatures.size){
          [...this.draggableFeatures.keys()].forEach((feature_id) => {
            const feature = this.map_layers.get('markers').getFeatureById(feature_id);
            this.setIsDraggable(feature, false);
          });
          this.draggableFeatures = new Map();
        }
      }
    }

    setDefaultProjectMapStyle() {
      this.hasCustomMapStyles = false;
      this.styleList = defaultStyleSheet;
      this.mapMode = 'defaultMode';
      Vue.set(this.mapOptions, 'styles', mapStyles[this.mapMode]);
    }

    getProjectMapStyles() {
      try {
        const styleList = [{ name: 'Default', value: 'defaultMode' }];
        const map_styles = PropUtils.getProperty(this.projectProperties, 'dashboard.map_styles');
        let defaultType = 'defaultMode';
        let defaultStyle = mapStyles['defaultMode'];
        if (map_styles && map_styles.value) {
          this.customMapStyles = map_styles.value;
          Object.entries(this.customMapStyles).forEach(([map_type, style]) => {
            const current_style = style[0];
            if (current_style.default) {
              defaultType = map_type;
              defaultStyle = current_style.style[0];
            }
            styleList.push({name: map_type, value: map_type});
          });
        }
        if (styleList.length > 1) {
          this.hasCustomMapStyles = true;
          this.mapMode = defaultType;
          this.styleList = styleList;
          // localStorage.setItem('mapMode', defaultType);
          Vue.set(this.mapOptions, 'styles', defaultStyle);
        } else {
          this.setDefaultProjectMapStyle();
        }
      } catch (e) {
        console.log('err', e);
        this.setDefaultProjectMapStyle();
      }
    }

    setBounds(markers) {
      if (typeof this.$gmapApiPromiseLazy !== 'function') {
        return;
      }

      this.$gmapApiPromiseLazy().then(() => {
        if (typeof google === 'undefined' || !google.maps) {
          return;
        }

        const bounds = new google.maps.LatLngBounds();
        if (!markers.length) {
          bounds.extend(new google.maps.LatLng(this.projectDefaultLocation.lat, this.projectDefaultLocation.lng));
          if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            bounds.extend(new google.maps.LatLng(
              bounds.getNorthEast().lat() + 0.01,
              bounds.getNorthEast().lng() + 0.01
            ));
            bounds.extend(new google.maps.LatLng(
              bounds.getNorthEast().lat() - 0.01,
              bounds.getNorthEast().lng() - 0.01
            ));
          }
        } else {
          // Single O(n) min/max scan. Avoids allocating N google.maps.LatLng objects
          // and N internal extend traversals for thousands of markers.
          let minLat = Infinity;
          let maxLat = -Infinity;
          let minLng = Infinity;
          let maxLng = -Infinity;
          for (const marker of markers) {
            const loc = marker['meta.location'];
            if (!loc) continue;
            const lat = +loc.lat;
            const lng = +loc.lng;
            if (lat < minLat) minLat = lat;
            if (lat > maxLat) maxLat = lat;
            if (lng < minLng) minLng = lng;
            if (lng > maxLng) maxLng = lng;
          }
          if (minLat !== Infinity) {
            bounds.extend(new google.maps.LatLng(minLat, minLng));
            bounds.extend(new google.maps.LatLng(maxLat, maxLng));
          }
        }
        if (this.$refs.map && this.$refs.map.$mapObject) {
          this.$refs.map.$mapObject.fitBounds(bounds);
        }
      });
    }

    linkLayerToMap(layer_name){
      const layer = this.map_layers.get(layer_name);
      Vue.set(this.advancedLocations, layer_name, !this.advancedLocations[layer_name]);
      this.advancedLocations[layer_name]
        ? layer.setMap(this.map)
        : layer.setMap(null);
    }

    clearPolylines(){
      if (this.polyline) this.polyline.setMap(null);
      if (this.polyline1) this.polyline1.setMap(null);
      if (this.polyline2) this.polyline2.setMap(null);
    }

    setDragMarker(value){
      this.dragMarker = value;
    }

    revertDrag(){
      this.confirmDragDialog = false;
      const point = this.map_layers.get('markers').getFeatureById(this.dragMarker.id);
      point.setGeometry(new google.maps.Data.Point({...this.dragPrevLocation}));
      this.dragMarker = null;
      this.clearDragLocations();
    }
    
    async updateDevicePosition(){
      const drag_marker = cloneDeep(this.dragMarker);
      const current_location = {...this.dragCurrentLocation};
      this.dragMarker = null;
      this.confirmDragDialog = false;
      if (this.$route.path.includes('/virtual-devices')) this.$emit('changeVirtualLocation', current_location);

      // Two variants per property:
      //   • numeric  — full-precision number lat/lng. Required by the schema
      //                on `meta.install_location`, and preferred for `meta.location`.
      //   • string   — legacy fallback used if the backend (or a per-project
      //                schema override) rejects numbers.
      // We try numeric first per property; on failure we silently retry with
      // the string variant. Toasts are emitted ONCE at the end based on the
      // combined outcome — no error toast if a fallback rescued the update.
      const lat_num = parseFloat(current_location.lat);
      const lng_num = parseFloat(current_location.lng);
      const lat_str = String(current_location.lat);
      const lng_str = String(current_location.lng);

      const locationOk = await this.tryUpdatePropertyWithFallback(
        drag_marker.id,
        'meta.location',
        { lat: lat_num, lng: lng_num },
        { lat: lat_str, lng: lng_str }
      );

      // meta.location is the source of truth for the marker's position.
      // If both numeric and string attempts failed, surface the failure and
      // bail out — there is no point attempting meta.install_location when
      // the primary location write itself was rejected.
      if (!locationOk) {
        this.clearDragLocations();
        this.$store.dispatch('Global/throwNotify', {
          type: 'error',
          title: `${this.$t('Error')}!`,
          text: this.$t(`Couldn't update data`)
        });
        return;
      }

      // meta.location succeeded (with one of the variants). Apply the UI
      // updates that depend on it, and notify success.
      this.closeInfoWindow();
      this.map_layers.get('markers').getFeatureById(drag_marker.id).setGeometry(new google.maps.Data.Point({...current_location}));
      this.setMarkerCoords(current_location, drag_marker.id);
      this.updateMarkerAddress(drag_marker.id, current_location);
      this.$store.dispatch('Global/throwNotify', {
        type: 'success',
        title: `${this.$t('Success')}!`,
        text: this.$t('Device location successfully updated')
      });

      // Now that meta.location is committed, attempt the secondary
      // meta.install_location write (numeric → string fallback) and emit
      // its own success/failure toast independently.
      if (drag_marker.hasOwnProperty('meta.install_location') && drag_marker['meta.install_location']) {
        const installOk = await this.updateInstallLocationProperty(drag_marker, current_location);
        this.$store.dispatch('Global/throwNotify', {
          type: installOk ? 'success' : 'error',
          title: installOk ? `${this.$t('Success')}!` : `${this.$t('Error')}!`,
          text: installOk
            ? this.$t('Install location successfully updated')
            : this.$t(`Couldn't update install location`)
        });
      }

      this.clearDragLocations();
    }

    async tryUpdateProperty(device_id, name, value) {
      // Silent single-attempt PATCH. Returns true on 2xx, false on any error.
      // Errors are intentionally swallowed (no toast, no rethrow) so the
      // caller can implement a numeric-then-string fallback without the user
      // seeing a transient "Couldn't update data" message between attempts.
      try {
        await API.patch(Types.DEVICES, 'properties', value, {
          itemID: device_id,
          query: { name }
        });
        return true;
      } catch (e) {
        return false;
      }
    }

    async tryUpdatePropertyWithFallback(device_id, name, numericValue, stringValue) {
      if (await this.tryUpdateProperty(device_id, name, numericValue)) return true;
      return this.tryUpdateProperty(device_id, name, stringValue);
    }
    
    clearDragLocations(){
      this.dragPrevLocation = {lat: null, lng: null};
      this.dragCurrentLocation = {lat: null, lng: null};
    }
    
    async updateMarkerAddress(device_id, current_location){
      const url = 'device/update_estimated_address';
      const body = {
        device_id,
        company_id: this.$store.state.User.project.company,
        project_id: this.$store.state.User.project.id,
        lat: current_location.lat,
        lng: current_location.lng
      };

      const response = await API.dashboardAPI(url, 'POST', {}, body);
      if (response && response.address) {
        const map_marker = this.markers_map.get(device_id);
        const meta_device = map_marker['meta.device'];
        const address_field = Utils.hasCabinetClass(map_marker['meta.category'].category) ? 'cabinet_address' : 'address';
        meta_device[address_field] = response.address;
        map_marker['meta.device'] = meta_device;
      }
    }

    async getLastPropertyHistory(property_name, device_id) {
      const property_history = await API.get(
        Types.DEVICES,
        `${device_id}/properties/${property_name}/history`,
        {}
      );
      return property_history.length ? property_history[0] : '';
    }

    async updateInstallLocationProperty(device, new_location) {
      const last_location = this.$store.state.User.role === 'CA'
        ? await this.getLastPropertyHistory('meta.location', device.id)
        : '';

      // The schema on `meta.install_location` requires numeric lat/lng on
      // every sub-location, not just the one we're changing. Build two full
      // variants (numeric / string) so the fallback can recover from a
      // backend that rejects either type.
      const numericProp = this.buildInstallLocationVariant(
        device['meta.install_location'],
        { lat: parseFloat(new_location.lat), lng: parseFloat(new_location.lng) },
        last_location,
        device.id,
        'numeric'
      );
      const stringProp = this.buildInstallLocationVariant(
        device['meta.install_location'],
        { lat: String(new_location.lat), lng: String(new_location.lng) },
        last_location,
        device.id,
        'string'
      );

      const ok = await this.tryUpdatePropertyWithFallback(
        device.id,
        'meta.install_location',
        numericProp,
        stringProp
      );

      if (ok) {
        // Mirror the saved value into the cached marker so subsequent reads
        // (info window, re-renders) reflect the new manual_location and any
        // gps_location override we applied.
        device['meta.install_location'].manual_location = {
          lat: String(new_location.lat),
          lng: String(new_location.lng)
        };
        if (last_location && last_location.updater && last_location.updater.toString() === device.id) {
          try {
            device['meta.install_location'].gps_location = JSON.parse(last_location.value);
          } catch (e) {}
        }
      }

      return ok;
    }

    buildInstallLocationVariant(install_location_prop, manual_location, last_location, device_id, mode) {
      const variant = JSON.parse(JSON.stringify(install_location_prop || {}));
      variant.manual_location = manual_location;

      // Normalize sibling sub-locations to satisfy the schema the backend
      // is enforcing for this variant. All four sub-location keys are
      // preserved on both variants (the schema's `required: ["lat","lng"]`
      // still holds — the keys exist, the values may be null).
      //   • numeric — `type: ["number", "null"]`. Coerce to number when
      //               parseable; otherwise send `null`.
      //   • string  — legacy schema; coerce to string, empties become "".
      const coerce = (val) => {
        if (mode === 'numeric') {
          if (val === null || val === undefined || val === '') return null;
          const n = parseFloat(val);
          return isNaN(n) ? null : n;
        }
        if (val === null || val === undefined) return '';
        return String(val);
      };

      ['gps_location', 'app_location', 'gis_location'].forEach((key) => {
        const sub = variant[key];
        if (!sub) return;
        variant[key] = {
          lat: coerce(sub.lat),
          lng: coerce(sub.lng)
        };
      });

      // Optionally overlay last-known meta.location into gps_location for
      // CA-role users (preserves the original behavior of this method).
      if (last_location && last_location.updater && last_location.updater.toString() === device_id) {
        try {
          const lv = JSON.parse(last_location.value);
          variant.gps_location = {
            lat: coerce(lv.lat),
            lng: coerce(lv.lng)
          };
        } catch (e) { /* ignore */ }
      }

      return variant;
    }

    removeAllLayerFeatures(layer_name){
      this.map_layers.get(layer_name).forEach((feature) => {
        this.map_layers.get('markers').remove(feature);
      });
    }
   
  @Watch('devices')
  @Watch('loadingDevices')
  whenMapReady() {
    if (!this.map) return;
    // While the loader is shown, no markers are visible — skip all rendering work so it
    // does not apply TCP backpressure to the in-flight data streams.
    if (this.loadingDevices) return;

    const hasDevices = this.devices && (this.devices as any[]).length > 0;

    // When streaming completes, two reactive sources change in close succession:
    //   1. `loadingDevices` flips to false (sync, in onStreamingComplete).
    //   2. `mapDevices` becomes populated (microtask later, after fetchData's
    //      `await setFilterDevices()` resumes).
    // These fire whenMapReady twice in different microtask ticks, so Vue can't
    // batch them. If we burn `__renderedOnce` on the first (empty) fire, the
    // second fire (with the full device list) falls into the 1.5 s debounce
    // path below — which calls setMarkerInformation a second time, clearing
    // the data layer and re-adding all 28k features. Visually: markers appear,
    // disappear ~1.5 s later, then return. Holding `__renderedOnce` until we
    // actually have data to render avoids that flash.
    // Capture the previous state BEFORE flipping __renderedOnce so that the
    // very first render with real data uses the 0 ms fast-path; only true
    // subsequent updates pay the 1500 ms debounce.
    const wasRenderedOnce = this.__renderedOnce;
    if (hasDevices) this.__renderedOnce = true;

    // Use the same debounce timer slot for both the first render (0 ms) and
    // subsequent updates (1500 ms). Each fire clears the previous timer, so
    // multiple fires within the same tick coalesce into a single render
    // against the latest data — exactly what we want when streaming
    // completes and `loadingDevices` + `mapDevices` change back-to-back.
    const delay = wasRenderedOnce ? 1500 : 0;
    if (this.__markerInfoTimer) clearTimeout(this.__markerInfoTimer);
    this.__markerInfoTimer = setTimeout(() => {
      this.__markerInfoTimer = null;
      this.setMarkerInformation();
    }, delay);
  }

  @Watch('projectProperties')
  whenProjectPropertiesChanged(prev, next) {
    if (prev.length) {
      this.getProjectMapStyles();
    }
  }
}

export default GoogleMap;
